import { createAction, createSlice } from "@reduxjs/toolkit";
import { CashManagementNotificationSettings } from "../models/CashManagement";
import { UUID } from "../utils";
import listFactory from "./listFactory";

const {
  slicePart,
  selectors,
} = listFactory<CashManagementNotificationSettings>(
  "cashManagementNotification"
);

const initialState = {
  ...slicePart.initialState,
  testResponse: {},
  // outstandingCashManagementNotifications: {},
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    updateItem: slicePart.reducers.updateItem,
    updateNotificationStatus: (state, action) => {
      const { id, data } = action.payload;
      // only `enable` because `disable` is done on backend after some time
      if (data.status) {
        slicePart.reducers.updateItem(state, {
          ...action,
          payload: {
            id,
            itemPart: {
              enabled: true,
            },
          },
        });
        // state.notificationsSettings[id] = {
        //   ...state.notificationsSettings[id],
        //   enabled: true,
        // };
      }
    },
    // setOutstandingCashManagementNotifications: (state, action) => {
    //   const { id, data } = action.payload;
    //   state.outstandingCashManagementNotifications[id] = data;
    // },
    setCashManagementNotificationTestResponse: (state, action) => {
      const { data } = action.payload;
      state.testResponse = data;
    },
  },
});

export const fetchCashManagementNotificationsSettings = createAction<{
  id: UUID;
}>("fetchCashManagementNotificationsSettings");
export const updateCashManagementNotificationsSettings = createAction<{
  id: UUID;
  data: CashManagementNotificationSettings;
}>("updateCasManagementhNotificationsSettings");
export const createCashManagementNotificationsSettings = createAction<{
  id: UUID;
  data: CashManagementNotificationSettings;
}>("createCasManagementhNotificationsSettings");
export const testCashManagementNotifications = createAction<
  { id: UUID },
  "testCashManagementNotifications"
>("testCashManagementNotifications");
export const setCashManagementNotificationsSettingsActiveFlag = createAction<{
  id: UUID;
  data: CashManagementNotificationSettings;
}>("setCashManagementNotificationsSettingsActiveFlag");

export const {
  updateNotificationStatus,
  setCashManagementNotificationTestResponse,
  setItem: setCashNotificationsSettings,
  updateItem,
} = slice.actions;

export const {
  selectItem: selectCashManagementNotificationsSettings,
} = selectors;
export const selectCashManagementNotificationsTestResponse = (state: any) => {
  return state.cashManagementNotification.testResponse;
};
export const selectOutstandingCashManagementNotifications = (id: UUID) => (
  state: any
) => {
  return state.cashManagementNotification
    .outstandingCashManagementNotifications[id];
};
export default slice.reducer;

export const cashManagementNotificationsOperationPaths = (id?: UUID) => {
  return {
    details: ["cashManagement", "settlementNotifications", id, "details"],
    update: ["cashManagement", "settlementNotifications", "update", id],
    create: ["cashManagement", "settlementNotifications", "create", id],
    active: ["cashManagement", "settlementNotifications", id, "activeFlag"],
  };
};
